import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import OkIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles(theme => ({
  evaluation: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      position: 'relative',
    },
    '& h3': {
      textAlign: 'center',
      color: '#666',
      background: '#eee',
      padding: '0.5em',
      marginTop: 0,
      fontWeight: 400,
      position: 'relative',
    },
    '& h1': {
      textAlign: 'center',
      color: theme.palette.primary.main,
    },
    '& h2': {
      textAlign: 'center',
      color: theme.palette.secondary.main,
    },
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  sentence: {
    textAlign: 'center',
    fontSize: 24,
    margin: '1em 0',
  },
  words: {
    position: 'relative',
    height: 190,
    width: 380,
    maxWidth: '100%',
    margin: '0 auto',
    fontSize: 24,
    transition: 'opacity 0.3s',
    '& > div': {
      display: 'inline-block',
      borderRadius: 4,
      position: 'absolute',
      cursor: 'grab',
      color: theme.palette.primary.main,
      background: '#f1f3ff',
      padding: '0 0.5em',
      '&:active': {
        cursor: 'grabbing',
        color: theme.palette.secondary.main,
      },
      '&:nth-child(1)': {
        left: 0,
        top: 0,
      },
      '&:nth-child(2)': {
        right: 0,
        top: '1.5em',
      },
      '&:nth-child(3)': {
        right: '37%',
        top: '3em',
      },
      '&:nth-child(4)': {
        left: '12%',
        top: '4.5em',
      },
      '&:nth-child(5)': {
        right: '16%',
        top: '6em',
      },
    },
    '& > div.active': {
      color: theme.palette.secondary.main,
    },
    '& > div.hidden': {
      visibility: 'hidden',
    },
  },
  ok: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    color: 'green',
    marginLeft: '-2em',
    '& svg': {
      fontSize: '4em',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

let timeout1 = 0;

function Evaluation(props) {
  const classes = useStyles();
  const [ no, setNo ] = useState(0);
  const [ solved, setSolved ] = useState({ "1": false, "2": false });
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const [ finished, setFinished ] = useState(false);
  const [ showOk, setShowOk ] = useState(false);
  const parts = exercise[no];
  const len = exercise.length;
  const correct = {};
  correct[1] = parts.correct1;
  correct[2] = parts.correct2;
  let wordNo = false;
  const refs = {};
  refs[1] = useRef(null);
  refs[2] = useRef(null);
  refs[3] = useRef(null);
  refs[4] = useRef(null);
  refs[5] = useRef(null);

  useEffect(() => {
    startStats(type);
    return () => {
      clearTimeout(timeout1);
    }
    // eslint-disable-next-line
  }, []);

  const next = () => {
    if (no < len - 1) {
      setNo(no + 1);
      action();
      showWords();
      setSolved({ "1": false, "2": false });
    } else {
      finish();
    }
  }

  const drag = no => {
    clearActive();
    action();
    refs[no].current.classList.add('active');
    wordNo = no;
  }

  const drop = no => {
    action();
    clearActive();
    if (correct[no] === wordNo) {
      props.media.success();
      refs[wordNo].current.classList.add('hidden');
      setSolved({ ...solved, [no]: true });
      if (solved[1] || solved[2]) {
        setShowOk(true);
        timeout1 = setTimeout(() => {
          setShowOk(false);
          next();
        }, 2000);
      }
    } else {
      if (wordNo !== false) props.media.failure();
    }
  }

  const clearActive = () => {
    for (let i = 1; i < 6; i++) {
      refs[i].current.classList.remove('active');
    }
  }

  const showWords = () => {
    for (let i = 1; i < 6; i++) {
      refs[i].current.classList.remove('hidden');
    }
  }

  const finish = () => {
    setFinished(true);
    finishExercise();
    props.media.finish();
  }

  return (
    <div className={classes.evaluation}>
      {!finished && <div>
      <h3>Uzupełnij zdania podanymi wyrazami</h3>
        
        <div className={classes.sentence}>
          {parts.text1}
          {!solved[1] && <span onDragOver={ev => ev.preventDefault()} onDrop={() => drop(1)} onClick={() => drop(1)}> _____ </span>}
          {solved[1] && <span> {parts['answer' + correct[1]]} </span>}
          {parts.text2}
          {!solved[2] && <span onDragOver={ev => ev.preventDefault()} onDrop={() => drop(2)} onClick={() => drop(2)}> _____ </span>}
          {solved[2] && <span> {parts['answer' + correct[2]]} </span>}
          {parts.text3}
        </div>
        {showOk && <div className={classes.ok}><OkIcon /></div>}
        <div className={classes.words} style={{opacity: showOk ? 0 : 1}}>
          <div draggable="true" onDragStart={() => drag(1)} onClick={() => drag(1)} ref={refs[1]}>{parts.answer1}</div>
          <div draggable="true" onDragStart={() => drag(2)} onClick={() => drag(2)} ref={refs[2]}>{parts.answer2}</div>
          <div draggable="true" onDragStart={() => drag(3)} onClick={() => drag(3)} ref={refs[3]}>{parts.answer3}</div>
          <div draggable="true" onDragStart={() => drag(4)} onClick={() => drag(4)} ref={refs[4]}>{parts.answer4}</div>
          <div draggable="true" onDragStart={() => drag(5)} onClick={() => drag(5)} ref={refs[5]}>{parts.answer5}</div>
        </div>  
        <div className={classes.action}><span>{no + 1}/{len} </span></div>
        
      </div>}
      {finished && <div>
        <h1>THE END</h1>
        <h2>Congratulations !!!</h2>
        <br />
        <div className={classes.action}>
          <Button variant="contained" onClick={() => close()}>Close</Button>
        </div>
      </div>}
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(Evaluation);
